import { Stack, useRadioGroup } from '@chakra-ui/react';

import { RadioCard } from '../RadioCard';

export const RadioGroup = ({ name, options, onChange, defaultValue }) => {
	const { getRootProps, getRadioProps } = useRadioGroup({
		defaultValue,
		name,
		onChange,
	});
	const group = getRootProps();
	const values = Object.keys(options);
	const itemWidth = 100 / values.length;
	return (
		<Stack w="100%" pb={6} {...group} direction={['column', 'row']}>
			{values.map(value => {
				const radio = getRadioProps({ value });
				return (
					<RadioCard w={['100%', `${itemWidth}%`]} key={value} {...radio}>
						{options[value]}
					</RadioCard>
				);
			})}
		</Stack>
	);
};
